import { render, staticRenderFns } from "./PerformanceHighlights.vue?vue&type=template&id=b95fe928&scoped=true&"
import script from "./PerformanceHighlights.vue?vue&type=script&lang=ts&"
export * from "./PerformanceHighlights.vue?vue&type=script&lang=ts&"
import style0 from "./PerformanceHighlights.vue?vue&type=style&index=0&id=b95fe928&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b95fe928",
  null
  
)

export default component.exports